<q9-icon-button
  (click)="zoomIn()"
  icon="action_icons:zoom_in"
  q9Track="DEPENDENCY_TREE.ZOOM_IN"
  [tooltip]="'DA.ZOOM_IN' | translate"></q9-icon-button>

<q9-icon-button
  (click)="zoomOut()"
  icon="action_icons:zoom_out"
  q9Track="DEPENDENCY_TREE.ZOOM_OUT"
  [tooltip]="'DA.ZOOM_OUT' | translate"></q9-icon-button>

<mat-divider vertical="true"></mat-divider>

<q9-icon-button
  icon="question"
  cdkOverlayOrigin
  #tips="cdkOverlayOrigin"
  (click)="toggleTips()"
  [tooltip]="'DA.TIPS' | translate"></q9-icon-button>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayPanelClass="tips-overlay"
  (overlayOutsideClick)="toggleTips()"
  [cdkConnectedOverlayOrigin]="tips"
  [cdkConnectedOverlayOpen]="openTips()">
  <mat-card>
    <mat-card-content>
      <div>
        <q9-tag color="accent">{{ 'DA.SCROLL_TIP' | translate }}</q9-tag>

        <span>{{ 'DA.SCROLL_ACTION' | translate }}</span>
      </div>

      <div>
        <q9-tag color="accent">{{ 'DA.DRAG_TIP' | translate }}</q9-tag>

        <span>{{ 'DA.DRAG_ACTION' | translate }}</span>
      </div>

      <div>
        <span class="help-circle">+</span>
        <span>{{ 'DA.EXPAND_NODE_ACTION' | translate }}</span>
      </div>

      <div>
        <span class="help-circle-opened"></span>
        <span>{{ 'DA.EMPTY_NODE_ACTION' | translate }}</span>
      </div>

      <div>
        <span class="help-filled-circle"></span>
        <span>{{ 'DA.GROUPING_NODE_DESCRIPTION' | translate }}</span>
      </div>

      <div>
        <span class="help-stroke"></span>
        <span>{{ 'DA.SELECTED_NODE_DESC' | translate }}</span>
      </div>

      <div>
        <mat-icon class="icon-info" svgIcon="action_icons:info"></mat-icon>
        <span>{{ 'DA.CLICK_FOR_INFO' | translate }}</span>
      </div>

      <div>
        <mat-icon class="icon-info" svgIcon="action_icons:info"></mat-icon>
        <span>{{ 'DA.RIGHT_CLICK_FOR_INFO' | translate }}</span>
      </div>

      <mat-divider></mat-divider>

      <q9-link-button [href]="dependencyTreeHelpLink">
        {{ 'DA.HELP_LINK' | translate }}
      </q9-link-button>
    </mat-card-content>
  </mat-card>
</ng-template>
